module.exports = __webpack_public_path__ + "static/img/advantage3.9e6d9bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/advantage3.png
// module id = 22aH
// module chunks = 0